import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.555 17.495a.7.7 0 0 1 .99-.99l2.1 2.1a.7.7 0 0 1 0 .99l-2.1 2.1a.7.7 0 0 1-.99-.99l.9-.905H17.6v2.8h7v-7h-7v2.8h2.856l-.901-.905zm5.046-3.295A1.4 1.4 0 0 1 26 15.599V22.6A1.4 1.4 0 0 1 24.601 24H17.6a1.4 1.4 0 0 1-1.399-1.399V19.8h-2.801A1.4 1.4 0 0 1 12 18.401V11.4A1.4 1.4 0 0 1 13.399 10H20.4a1.4 1.4 0 0 1 1.399 1.399V14.2h2.801zM20.4 11.4h-7v7h2.8v-2.801a1.4 1.4 0 0 1 1.399-1.399H20.4v-2.8z" transform="translate(-12 -10)" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconToggle extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
